import { DebugOfferState } from './offerDebugState';
import type { OfferSystemConfig } from '../../../libs/offerSystem/offerSystemTypes';
import type { Condition } from '../conditionsTypes';
import type { OffersGameData } from '../offersTypes';
import { OfferLocation, OfferTrigger } from '../offersTypes';
import { conditions } from '../conditions';
import { offersConfig } from '../offersConfig';
import type { OfferSystemData } from '../../../libs/offerSystem/OfferSystemHistory';

const state = new DebugOfferState();

export const debugOfferSystemConfig: OfferSystemConfig<DebugOfferState, Condition, OffersGameData> = {
  conditions,
  locations: Object.values(OfferLocation),
  offers: offersConfig,
  purchaseHistory: {},
  supportedLanguages: ['en_US', 'it_IT', 'fr_FR', 'de_DE', 'es_ES', 'pt_PT', 'pl_PL', 'nl_NL', 'ko_KR', 'ja_JP'],
  saveHandler(_: OfferSystemData): void {},
  triggers: Object.values(OfferTrigger),
  getCurrentTime: () => state.getCurrentTime(),
  state,
};
